import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fisk_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  const lt = sessionStorage.getItem("fisk_lt_token");
  if (lt) {
    config.headers = config.headers || {};
    config.headers["X-LT-Token"] = lt;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Ocorreu um erro.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function streamUrl(mediaId) {
  const token = localStorage.getItem("fisk_token");
  const lt = sessionStorage.getItem("fisk_lt_token");
  let url = `${API}/stream/${mediaId}?token=${encodeURIComponent(token || "")}`;
  if (lt) url += `&lt=${encodeURIComponent(lt)}`;
  return url;
}

export function getLTToken() {
  return sessionStorage.getItem("fisk_lt_token") || "";
}

export function setLTToken(t) {
  if (t) sessionStorage.setItem("fisk_lt_token", t);
  else sessionStorage.removeItem("fisk_lt_token");
}

export default api;
